export default __webpack_public_path__ + "static/media/COM.cfdcaeff.webp";